// dependencies
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { GenerateProcess } from "redux-process";
import React, { useState, useEffect, useRef } from "react";
import moment from "moment";

// components
import Button from "Components/Button";
import DatePicker from "react-datepicker";
import TextInput from "Components/Inputs/Text";
import Textarea from "Components/Inputs/Textarea";
import CancelConfirmModal from "./CancelConfirmation";

// utils

// css
import css from "./CompanyInvoice";
import "react-datepicker/dist/react-datepicker.css";

const CompanyInvoice = (props) => {
	const mountedRef = useRef(false);
	const { companyID } = props;
	const [displayCancelConfirmationModal, setDisplayCancelConfirmationModal] = useState(false);
	const [newInvoice, setNewInvoice] = useState(true);

	const defaultInvoiceFields = {
		price: "",
		start: "",
		end: "",
		unit_price: "",
		frequency: "",
		seats: "",
		terms: "",
	};

	const [invoiceFields, setInvoiceFields] = useState(defaultInvoiceFields);

	const fetchCompanyInvoice = async () => {
		const request = await props.fetchCompanyInvoice(companyID);
		if (request.succeeded) {
			if (request.response && Object.keys(request.response).length > 0) {
				return { containsInvoice: true, invoice: request.response };
			}
		}
		return { containsInvoice: false, invoice: {} };
	};

	const handleChange = (field, value) => {
		const invoiceFieldsCopy = { ...invoiceFields };
		invoiceFieldsCopy[field] = value;
		setInvoiceFields(invoiceFieldsCopy);
	};

	const setInvoice = (invoice) => {
		const invoiceCopy = { ...invoice };
		setNewInvoice(false);

		Object.keys(invoice).map((key) => {
			if (key === "start" || key === "end") {
				invoiceCopy[key] = moment(invoice[key], "YYYY-MM-DD HH:mm").toDate();
			}
		});
		setInvoiceFields(invoiceCopy);
	};

	const updateCompanyInvoice = async (payload) => {
		await props.updateCompanyInvoice(companyID, payload);
	};

	const handleUpdateInvoice = async () => {
		await updateCompanyInvoice(invoiceFields);
		setNewInvoice(false);
	};

	// effect just for tracking mounted state and prevent memory leak
	useEffect(() => {
		mountedRef.current = true;
		return () => {
			mountedRef.current = false;
		};
	}, []);

	// done this way due to memory leak issue
	useEffect(() => {
		fetchCompanyInvoice().then((message) => {
			if (mountedRef.current) {
				if (message.containsInvoice) {
					setInvoice(message.invoice);
				}
			}
		});
	}, []);

	return (
		<div className={css.main}>
			<div className={css.CompanyInvoice}>
				<div className={css.inputContainer}>
					<div className={css.label}>Total Price:</div>
					<TextInput
						value={invoiceFields.price || ""}
						onChange={(value) => handleChange("price", value)}
						type="number"
					/>
				</div>
				<div className={css.inputContainer}>
					<div className={css.label}>Start Date:</div>
					<DatePicker
						selected={invoiceFields.start}
						onChange={(date) => handleChange("start", date)}
						dateFormat="M/dd/yyyy"
					/>
				</div>
				<div className={css.inputContainer}>
					<div className={css.label}>End Date:</div>
					<DatePicker
						selected={invoiceFields.end}
						onChange={(date) => handleChange("end", date)}
						dateFormat="M/dd/yyyy"
					/>
				</div>
				<div className={css.inputContainer}>
					<div className={css.label}>Unit/Price:</div>
					<TextInput
						value={invoiceFields.unit_price || ""}
						onChange={(value) => handleChange("unit_price", value)}
						type="number"
					/>
				</div>
				<div className={css.inputContainer}>
					<div className={css.label}>Billing Frequency:</div>
					<TextInput
						value={invoiceFields.frequency || ""}
						onChange={(value) => handleChange("frequency", value)}
					/>
				</div>
				<div className={css.inputContainer}>
					<div className={css.label}>Number of Employees:</div>
					<TextInput
						value={invoiceFields.seats || ""}
						onChange={(value) => handleChange("seats", value)}
						type="number"
					/>
				</div>
				<div className={css.inputContainer}>
					<div className={css.label}>Special Terms:</div>
					<Textarea value={invoiceFields.terms || ""} onChange={(value) => handleChange("terms", value)} />
				</div>
			</div>
			<div className={css.sideBySide}>
				<Button onClick={handleUpdateInvoice}>{newInvoice ? "Add" : "Update"} Invoice</Button>
				<Button onClick={() => setDisplayCancelConfirmationModal(true)} className={css.cancelButton}>
					Cancel Invoice
				</Button>
			</div>

			{displayCancelConfirmationModal ? (
				<CancelConfirmModal
					handleClose={() => setDisplayCancelConfirmationModal(false)}
					companyID={companyID}
				/>
			) : null}
		</div>
	);
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	fetchCompanyInvoice: (companyID) => dispatch(GenerateProcess("GetCompanyInvoice", { companyID })),
	updateCompanyInvoice: (companyID, payload) =>
		dispatch(GenerateProcess("UpdateCompanyInvoice", { companyID, payload })),
});

CompanyInvoice.propTypes = {
	companyID: PropTypes.string.isRequired,
	fetchCompanyInvoice: PropTypes.func.isRequired,
	updateCompanyInvoice: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyInvoice);
